const TZ = "Asia/Kolkata";
const fmt = (opts) => new Intl.DateTimeFormat("en-GB", { timeZone: TZ, ...opts });
const D = (d) => new Date(d);

export const fmtDate = (d) => fmt({ day: "numeric", month: "long", year: "numeric" }).format(D(d));
export const fmtTime = (d) => fmt({ hour: "numeric", minute: "2-digit", hour12: true }).format(D(d)).toUpperCase();
export const fmtDay = (d) => fmt({ weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(D(d));
export const dateParts = (d) => ({
  month: fmt({ month: "short" }).format(D(d)),
  day: fmt({ day: "numeric" }).format(D(d)),
  weekday: fmt({ weekday: "short" }).format(D(d)),
});
export const isWeekendIST = (d) => ["Sat", "Sun"].includes(dateParts(d).weekday);

export const readTime = (text = "") => {
  const words = text.split(/\s+/).filter(Boolean).length;
  return `${Math.max(2, Math.ceil(words / 200))} min read`;
};
